import { cn } from "@repo/design-system/lib/utils";

export const fonts = cn("touch-manipulation font-sans antialiased");
